@if (cards$ | async; as cards) {
  @if (cards.length) {
    <div class="header" i18n [attr.data-testid]="'template-picker-header'">
      <mat-icon>{{ 'cards' | messageIcon }}</mat-icon>
      從卡片中挑選
    </div>
    <div class="container" [attr.data-testid]="'template-picker-container'">
      <div
        class="flex flex-row flex-wrap justify-between items-start gap-[16px]"
      >
        @for (card of cards; track card; let index = $index) {
          <div
            class="wrap flex-[0_0_225px]"
            (click)="toggleCard(index)"
            [attr.data-testid]="'template-card-item-' + index"
          >
            <div
              class="title"
              [attr.data-testid]="'template-card-title-' + index"
            >
              {{ card.templateName }}
            </div>
            <ms-card
              [card]="card"
              selectable="true"
              [ngClass]="{ selected: selected[index] }"
            >
            </ms-card>
            @if (selected[index]) {
              <span
                class="checkbox"
                [attr.data-testid]="'template-card-checkbox-' + index"
              >
                {{ selected[index] }}
              </span>
            }
          </div>
        }
      </div>
    </div>
    <div class="footer" [attr.data-testid]="'template-picker-footer'">
      @if (count) {
        <span i18n [attr.data-testid]="'selected-count'">
          已經選擇 {{ count }} 張卡片
        </span>
      }
      <button
        mat-raised-button
        color="primary"
        (click)="submit()"
        [disabled]="count === 0"
        i18n
        [attr.data-testid]="'submit-button'"
      >
        <mat-icon>done</mat-icon>
        確定
      </button>
    </div>
  } @else {
    <div class="container" [attr.data-testid]="'empty-container'">
      <gosu-landing-brand
        image="./assets/cards-landing.png"
        title="在圖像編輯器中建立卡片範本"
        i18n-title="在圖像編輯器中建立卡片範本"
        description="透過圖像編輯器的功能，您可以預先建立卡片範本。這樣一來在建立訊息時就可以統一訊息發送的風格，並提升企業形象及發送效率"
        i18n-description="
          透過圖像編輯器的功能，您可以預先建立卡片範本。這樣一來在建立訊息時就可以統一訊息發送的風格，並提升企業形象及發送效率
        "
        callToActionIcon="add"
        callToActionLabel="立即建立"
        i18n-callToActionLabel="立即建立"
        (callToAction)="createTemplate()"
        [attr.data-testid]="'empty-state-brand'"
      >
      </gosu-landing-brand>
    </div>
  }
} @else {
  <div class="container" [attr.data-testid]="'loading-container'">
    <gosu-loading i18n [attr.data-testid]="'loading-indicator'"
      >卡片讀取中，請稍候</gosu-loading
    >
  </div>
}
